import logo from '@/assets/images/logo.svg'
import bn1bd from '@/assets/images/hero-bg.jpeg';
import communities from '@/assets/images/communities.png';
import vote from '@/assets/images/vote.png';
import checked from '@/assets/images/checked.png';
import getStartedBgShape from '@/assets/images/bg-shape.png';
import userImg1 from '@/assets/images/user-img1.png';
import userImg2 from '@/assets/images/user-img2.png';
import userImg3 from '@/assets/images/user-img3.png';
import team1 from '@/assets/images/team-1.png';
import team2 from '@/assets/images/team-2.png';
import team3 from '@/assets/images/team-3.png';
import team4 from '@/assets/images/team-4.png';
import team5 from '@/assets/images/team-5.png';
import team6 from '@/assets/images/team-6.png';
import team7 from '@/assets/images/team-7.png';
import team8 from '@/assets/images/team-8.png';
import blogImg1 from '@/assets/images/blog1.jpeg';
import blogImg2 from '@/assets/images/blog2.jpeg';
import blogImg3 from '@/assets/images/blog3.jpeg';



let dlabData = {
    header: {
        navbar: [
            {
                title: 'Home',
                url: '/'
            },
            {
                title: 'Pages',
                url: '/about-us',
                submenu: [
                    {
                        title: 'About US',
                        url: '/about-us'
                    },
                    {
                        title: 'User Profile',
                        url: '/user-profile'
                    },
                    {
                        title: 'FAQ',
                        url: '/faq'
                    },
                    {
                        title: 'Jobs',
                        url: '/jobs'
                    },
                    {
                        title: 'Badges',
                        url: '/badges'
                    },
                    {
                        title: 'Users',
                        url: '/users'
                    },
                    {
                        title: 'Tags',
                        url: '/tags'
                    },
                    {
                        title: 'Privacy Policy',
                        url: '/privacy-policy'
                    },
                    {
                        title: '404 Not Found',
                        url: '/page-not-found'
                    }
                ]
            },
            {
                title: 'Blog',
                url: '/blog-no-sidebar',
                submenu: [
                    {
                        title: 'Grid no sidebar',
                        url: '/blog-no-sidebar'
                    },
                    {
                        title: 'Blog left sidebar',
                        url: '/blog-left-sidebar'
                    },
                    {
                        title: 'Blog Right sidebar',
                        url: '/blog-right-sidebar'
                    },
                    {
                        title: 'Blog Details',
                        url: '/blog-details'
                    }
                ]
            },
            {
                title: 'Contact US',
                url: '/contact'
            }
        ]
    },

    bannerone: {
        title: 'Join the World\'s biggest Q & A network',
        description: "If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.",
        btntext: 'Ask a Question',
        showbtnIcon: true,
        bgImage: bn1bd
    },
    questions: {
        qLists: {
            has_more: true,
            items: [
                {
                    title: "",
                    link: "/question-single",
                    answer_count: 1,
                    content_license: "CC BY-SA 4.0",
                    creation_date: 1658922014,
                    is_answered: false,
                    last_activity_date: 1658923234,
                    owner: {
                        account_id: 1,
                        display_name: "Mandera",
                        link: "https://example.com",
                        profile_image: "",
                        reputation: 1771,
                        user_id: 1,
                        user_type: "registered"
                    },
                    question_id: 1,
                    score: 23,
                    view_count: 7,
                    tags: [
                        'html',
                        'css'
                    ]
                }
            ],
            quota_max: 300,
            quota_remaining: 259
        },
        rightSidebar: {
            achivementCard: {
                title: 'Number Achievement',
                items: [
                    {
                        number: '999k',
                        designation: 'Questions'
                    },
                    {
                        number: '777k',
                        designation: 'Answers'
                    },
                    {
                        number: '666k',
                        designation: 'Answer accepted'
                    },
                    {
                        number: '565k',
                        designation: 'Users'
                    }
                ]
            },
            relatedQuestions: {
                title: 'Related Questions',
                questions: [
                    {
                        title: 'image picker and store them into firebase with flutter',
                        user: 'John Doe',
                        date: '22 May, 22'
                    },
                    {
                        title: 'Using web3 to call precompile contract',
                        user: 'Jonathon Doe',
                        date: '23 Jun, 22'
                    },
                    {
                        title: 'ViewErrorBag Empty - Validation is not passing errors',
                        user: 'Mr. Peter',
                        date: '29 Jun, 22'
                    }
                ]
            },
            trendingQuestions: {
                title: 'Trending Questions',
                questions: [
                    {
                        title: 'How can you cut an onion without crying?',
                        path: '/blog-details',
                        user: 'Antonin gavrel',
                        date: '11 Jul, 22'
                    },
                    {
                        title: 'Does flu vaccine protect against Coronavirus?',
                        path: '/blog-details',
                        user: 'wimax',
                        date: '23 Jul, 22'
                    },
                    {
                        title: 'How can you cut an onion without crying?',
                        path: '/blog-details',
                        user: 'Antonin gavrel',
                        date: '23 Jul, 22'
                    }
                ]
            },
            trendingTags: {
                title: 'Trending Tags',
                tags: [
                    {
                        name: 'Computer',
                        number: '34838'
                    },
                    {
                        name: 'Javascript',
                        number: '23444'
                    },
                    {
                        name: 'JAVA',
                        number: '94490'
                    },
                    {
                        name: 'HTML',
                        number: '24434'
                    },
                    {
                        name: 'CSS',
                        number: '43353'
                    },
                    {
                        name: 'c#',
                        number: '48484'
                    },
                    {
                        name: 'Angular',
                        number: '48288'
                    },
                    {
                        name: 'React',
                        number: '49385'
                    },
                    {
                        name: 'Vue',
                        number: '82988'
                    },
                    {
                        name: 'Machine Language',
                        number: '24848'
                    },
                    {
                        name: 'python',
                        number: '34838'
                    },
                    {
                        name: 'PHP',
                        number: '494888'
                    },
                    {
                        name: 'Swift',
                        number: '434838'
                    }
                ]
            }
        },
        questionDetails: {
            
        }
    },
    jobs: [
        {
            title: 'PHP & MySQL & HTML/CSS & JS Developers',
            author: 'John Doe',
            location: 'Netherlands',
            published: '1 hour ago',
            salary: '$45k - 75k',
            visaSponsor: true,
            paidRelocation: 'Paid relocation',
            tags: [
                {
                    title: 'javascript',
                    url: '/'
                },
                {
                    title: 'PHP',
                    url: '/'
                },
                {
                    title: 'node.js',
                    url: '/'
                },
                {
                    title: 'typescript',
                    url: '/'
                }
            ]
        },
        {
            title: 'Software Engineer - Fullstack',
            author: 'John Doe',
            location: 'USA',
            published: '1 hour ago',
            salary: '$45k - 75k',
            visaSponsor: true,
            paidRelocation: 'Paid relocation',
            tags: [
                {
                    title: 'javascript',
                    url: '/'
                },
                {
                    title: 'PHP',
                    url: '/'
                },
                {
                    title: 'typescript',
                    url: '/'
                }
            ]
        },
        {
            title: 'Senior Full-Stack (PHP, Node, React) Engineer (Remote)',
            author: 'John Doe',
            location: 'USA',
            published: '1 hour ago',
            salary: '$45k - 75k',
            visaSponsor: false,
            paidRelocation: 'Paid relocation',
            tags: [
                {
                    title: 'javascript',
                    url: '/'
                },
                {
                    title: 'PHP',
                    url: '/'
                },
                {
                    title: 'react.js',
                    url: '/'
                },
                {
                    title: 'typescript',
                    url: '/'
                }
            ]
        },
        {
            title: 'Senior Full-Stack (PHP, Node, React) Engineer (Remote)',
            author: 'John Doe',
            location: 'USA',
            published: '1 hour ago',
            salary: '$45k - 75k',
            visaSponsor: true,
            paidRelocation: 'Paid relocation',
            tags: [
                {
                    title: 'javascript',
                    url: '/'
                },
                {
                    title: 'PHP',
                    url: '/'
                },
                {
                    title: 'react.js',
                    url: '/'
                },
                {
                    title: 'typescript',
                    url: '/'
                }
            ]
        },
        {
            title: 'React Native Engineer at sustainable mobility Start-up (m/f/x)',
            author: 'John Doe',
            location: 'Netherlands',
            published: '20 mins ago',
            salary: '£30k - 50k',
            visaSponsor: true,
            paidRelocation: 'Paid relocation',
            tags: [
                {
                    title: 'javascript',
                    url: '/'
                },
                {
                    title: 'PHP',
                    url: '/'
                },
                {
                    title: 'react.js',
                    url: '/'
                },
                {
                    title: 'typescript',
                    url: '/'
                }
            ]
        },
        {
            title: 'Front-End Engineer (Remote)',
            author: 'John Doe',
            location: 'New York',
            published: '20 mins ago',
            salary: '€60k - 70k',
            visaSponsor: false,
            paidRelocation: 'Paid relocation',
            tags: [
                {
                    title: 'javascript',
                    url: '/'
                },
                {
                    title: 'PHP',
                    url: '/'
                },
                {
                    title: 'react.js',
                    url: '/'
                },
                {
                    title: 'typescript',
                    url: '/'
                }
            ]
        },
        {
            title: 'PHP & MySQL & HTML/CSS & JS Developers',
            author: 'John Doe',
            location: 'Netherlands',
            published: '1 hour ago',
            salary: '$45k - 75k',
            visaSponsor: true,
            paidRelocation: 'Paid relocation',
            tags: [
                {
                    title: 'javascript',
                    url: '/'
                },
                {
                    title: 'PHP',
                    url: '/'
                },
                {
                    title: 'node.js',
                    url: '/'
                },
                {
                    title: 'typescript',
                    url: '/'
                }
            ]
        },
        {
            title: 'Software Engineer - Fullstack',
            author: 'John Doe',
            location: 'USA',
            published: '1 hour ago',
            salary: '$45k - 75k',
            visaSponsor: true,
            paidRelocation: 'Paid relocation',
            tags: [
                {
                    title: 'javascript',
                    url: '/'
                },
                {
                    title: 'PHP',
                    url: '/'
                },
                {
                    title: 'typescript',
                    url: '/'
                }
            ]
        },
        {
            title: 'Senior Full-Stack (PHP, Node, React) Engineer (Remote)',
            author: 'John Doe',
            location: 'USA',
            published: '1 hour ago',
            salary: '$45k - 75k',
            visaSponsor: false,
            paidRelocation: 'Paid relocation',
            tags: [
                {
                    title: 'javascript',
                    url: '/'
                },
                {
                    title: 'PHP',
                    url: '/'
                },
                {
                    title: 'react.js',
                    url: '/'
                },
                {
                    title: 'typescript',
                    url: '/'
                }
            ]
        },
        {
            title: 'Senior Full-Stack (PHP, Node, React) Engineer (Remote)',
            author: 'John Doe',
            location: 'USA',
            published: '1 hour ago',
            salary: '$45k - 75k',
            visaSponsor: true,
            paidRelocation: 'Paid relocation',
            tags: [
                {
                    title: 'javascript',
                    url: '/'
                },
                {
                    title: 'PHP',
                    url: '/'
                },
                {
                    title: 'react.js',
                    url: '/'
                },
                {
                    title: 'typescript',
                    url: '/'
                }
            ]
        },
        {
            title: 'React Native Engineer at sustainable mobility Start-up (m/f/x)',
            author: 'John Doe',
            location: 'Netherlands',
            published: '20 mins ago',
            salary: '£30k - 50k',
            visaSponsor: true,
            paidRelocation: 'Paid relocation',
            tags: [
                {
                    title: 'javascript',
                    url: '/'
                },
                {
                    title: 'PHP',
                    url: '/'
                },
                {
                    title: 'react.js',
                    url: '/'
                },
                {
                    title: 'typescript',
                    url: '/'
                }
            ]
        },
        {
            title: 'Front-End Engineer (Remote)',
            author: 'John Doe',
            location: 'New York',
            published: '20 mins ago',
            salary: '€60k - 70k',
            visaSponsor: false,
            paidRelocation: 'Paid relocation',
            tags: [
                {
                    title: 'javascript',
                    url: '/'
                },
                {
                    title: 'PHP',
                    url: '/'
                },
                {
                    title: 'react.js',
                    url: '/'
                },
                {
                    title: 'typescript',
                    url: '/'
                }
            ]
        },
        {
            title: 'PHP & MySQL & HTML/CSS & JS Developers',
            author: 'John Doe',
            location: 'Netherlands',
            published: '1 hour ago',
            salary: '$45k - 75k',
            visaSponsor: true,
            paidRelocation: 'Paid relocation',
            tags: [
                {
                    title: 'javascript',
                    url: '/'
                },
                {
                    title: 'PHP',
                    url: '/'
                },
                {
                    title: 'node.js',
                    url: '/'
                },
                {
                    title: 'typescript',
                    url: '/'
                }
            ]
        },
        {
            title: 'Software Engineer - Fullstack',
            author: 'John Doe',
            location: 'USA',
            published: '1 hour ago',
            salary: '$45k - 75k',
            visaSponsor: true,
            paidRelocation: 'Paid relocation',
            tags: [
                {
                    title: 'javascript',
                    url: '/'
                },
                {
                    title: 'PHP',
                    url: '/'
                },
                {
                    title: 'typescript',
                    url: '/'
                }
            ]
        },
        {
            title: 'Senior Full-Stack (PHP, Node, React) Engineer (Remote)',
            author: 'John Doe',
            location: 'USA',
            published: '1 hour ago',
            salary: '$45k - 75k',
            visaSponsor: false,
            paidRelocation: 'Paid relocation',
            tags: [
                {
                    title: 'javascript',
                    url: '/'
                },
                {
                    title: 'PHP',
                    url: '/'
                },
                {
                    title: 'react.js',
                    url: '/'
                },
                {
                    title: 'typescript',
                    url: '/'
                }
            ]
        },
        {
            title: 'Senior Full-Stack (PHP, Node, React) Engineer (Remote)',
            author: 'John Doe',
            location: 'USA',
            published: '1 hour ago',
            salary: '$45k - 75k',
            visaSponsor: true,
            paidRelocation: 'Paid relocation',
            tags: [
                {
                    title: 'javascript',
                    url: '/'
                },
                {
                    title: 'PHP',
                    url: '/'
                },
                {
                    title: 'react.js',
                    url: '/'
                },
                {
                    title: 'typescript',
                    url: '/'
                }
            ]
        },
        {
            title: 'React Native Engineer at sustainable mobility Start-up (m/f/x)',
            author: 'John Doe',
            location: 'Netherlands',
            published: '20 mins ago',
            salary: '£30k - 50k',
            visaSponsor: true,
            paidRelocation: 'Paid relocation',
            tags: [
                {
                    title: 'javascript',
                    url: '/'
                },
                {
                    title: 'PHP',
                    url: '/'
                },
                {
                    title: 'react.js',
                    url: '/'
                },
                {
                    title: 'typescript',
                    url: '/'
                }
            ]
        },
        {
            title: 'Front-End Engineer (Remote)',
            author: 'John Doe',
            location: 'New York',
            published: '20 mins ago',
            salary: '€60k - 70k',
            visaSponsor: false,
            paidRelocation: 'Paid relocation',
            tags: [
                {
                    title: 'javascript',
                    url: '/'
                },
                {
                    title: 'PHP',
                    url: '/'
                },
                {
                    title: 'react.js',
                    url: '/'
                },
                {
                    title: 'typescript',
                    url: '/'
                }
            ]
        }
    ],
    userData: {
        title: 'Users',
        inputSearchPlaceholder: 'Type User name here...',
        selectOption: [
            {
                label: 'Reputation',
                value: 'reputation'
            },
            {
                label: 'Creation',
                value: 'creation'
            },
            {
                label: 'Name',
                value: 'name'
            },
            {
                label: 'Modified',
                value: 'modified'
            }
        ],
        users: [
            {
                account_id: 1,
                badge_counts: {
                    bronze: 9072,
                    silver: 8954,
                    gold: 828
                },
                creation_date: '12 Jan, 20',
                display_name: "Tanbir Ahmod",
                location: "USA",
                profile_image: userImg1,
                reputation: 1347160,
                user_id: 1,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 2,
                badge_counts: {
                    bronze: 9072,
                    silver: 8954,
                    gold: 828
                },
                creation_date: '12 Jan, 20',
                display_name: "John Doe",
                location: "USA",
                profile_image: userImg1,
                reputation: 1347160,
                user_id: 2,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 3,
                badge_counts: {
                    bronze: 345,
                    silver: 23,
                    gold: 353
                },
                creation_date: '12 Jan, 20',
                display_name: "Mr. Pitter",
                location: "USA",
                profile_image: userImg1,
                reputation: 1347160,
                user_id: 3,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 4,
                badge_counts: {
                    bronze: 345,
                    silver: 23,
                    gold: 353
                },
                creation_date: '12 Jan, 20',
                display_name: "John Doe",
                location: "USA",
                profile_image: userImg1,
                reputation: 1347160,
                user_id: 4,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 5,
                badge_counts: {
                    bronze: 345,
                    silver: 23,
                    gold: 353
                },
                creation_date: '12 Jan, 20',
                display_name: "Alia",
                location: "USA",
                profile_image: userImg1,
                reputation: 1347160,
                user_id: 5,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 6,
                badge_counts: {
                    bronze: 345,
                    silver: 23,
                    gold: 353
                },
                creation_date: '12 Jan, 20',
                display_name: "jezrael",
                location: "USA",
                profile_image: userImg1,
                reputation: 1347160,
                user_id: 6,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 7,
                badge_counts: {
                    bronze: 345,
                    silver: 23,
                    gold: 353
                },
                creation_date: '12 Jan, 20',
                display_name: "Jon Skeet",
                location: "USA",
                profile_image: userImg1,
                reputation: 1347160,
                user_id: 7,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 8,
                badge_counts: {
                    bronze: 345,
                    silver: 23,
                    gold: 353
                },
                creation_date: '12 Jan, 20',
                display_name: "Mina",
                location: "USA",
                profile_image: userImg2,
                reputation: 1347160,
                user_id: 8,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 9,
                badge_counts: {
                    bronze: 345,
                    silver: 23,
                    gold: 353
                },
                creation_date: '12 Jan, 20',
                display_name: "John Doe",
                location: "USA",
                profile_image: userImg2,
                reputation: 1347160,
                user_id: 9,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 10,
                badge_counts: {
                    bronze: 345,
                    silver: 23,
                    gold: 353
                },
                creation_date: '12 Jan, 20',
                display_name: "Tanbir",
                location: "USA",
                profile_image: userImg2,
                reputation: 1347160,
                user_id: 10,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 11,
                badge_counts: {
                    bronze: 345,
                    silver: 23,
                    gold: 353
                },
                creation_date: '12 Jan, 20',
                display_name: "TheMaster",
                location: "USA",
                profile_image: userImg2,
                reputation: 1347160,
                user_id: 11,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 12,
                badge_counts: {
                    bronze: 345,
                    silver: 23,
                    gold: 353
                },
                creation_date: '12 Jan, 20',
                display_name: "Mark Doe",
                location: "New York",
                profile_image: userImg2,
                reputation: 1347160,
                user_id: 12,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 13,
                badge_counts: {
                    bronze: 345,
                    silver: 23,
                    gold: 353
                },
                creation_date: '12 Jan, 20',
                display_name: "Jane Doe",
                location: "New York",
                profile_image: userImg2,
                reputation: 1347160,
                user_id: 13,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 14,
                badge_counts: {
                    bronze: 345,
                    silver: 23,
                    gold: 353
                },
                creation_date: '12 Jan, 20',
                display_name: "Jim Doe",
                location: "New York",
                profile_image: userImg2,
                reputation: 1347160,
                user_id: 14,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 15,
                badge_counts: {
                    bronze: 345,
                    silver: 23,
                    gold: 353
                },
                creation_date: '12 Jan, 20',
                display_name: "John Bollinger",
                location: "New York",
                profile_image: userImg1,
                reputation: 1347160,
                user_id: 15,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 16,
                badge_counts: {
                    bronze: 345,
                    silver: 23,
                    gold: 353
                },
                creation_date: '12 Jan, 20',
                display_name: "Tanbir",
                location: "New York",
                profile_image: userImg1,
                reputation: 1347160,
                user_id: 16,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 17,
                badge_counts: {
                    bronze: 345,
                    silver: 23,
                    gold: 353
                },
                creation_date: '12 Jan, 20',
                display_name: "Mihe",
                location: "New York",
                profile_image: userImg1,
                reputation: 1347160,
                user_id: 17,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 18,
                badge_counts: {
                    bronze: 345,
                    silver: 23,
                    gold: 353
                },
                creation_date: '12 Jan, 20',
                display_name: "Alex",
                location: "New York",
                profile_image: userImg1,
                reputation: 1347160,
                user_id: 18,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 19,
                badge_counts: {
                    bronze: 345,
                    silver: 23,
                    gold: 353
                },
                creation_date: '12 Jan, 20',
                display_name: "Mart",
                location: "New York",
                profile_image: userImg1,
                reputation: 1347160,
                user_id: 19,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 20,
                badge_counts: {
                    bronze: 345,
                    silver: 23,
                    gold: 353
                },
                creation_date: '12 Jan, 20',
                display_name: "Jhonathon",
                location: "New York",
                profile_image: userImg1,
                reputation: 1347160,
                user_id: 20,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 1,
                badge_counts: {
                    bronze: 9072,
                    silver: 8954,
                    gold: 828
                },
                creation_date: '12 Jan, 20',
                display_name: "Andy",
                location: "New York",
                profile_image: userImg1,
                reputation: 1347160,
                user_id: 1,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 1,
                badge_counts: {
                    bronze: 9072,
                    silver: 8954,
                    gold: 828
                },
                creation_date: '12 Jan, 20',
                display_name: "Kaiido",
                location: "New York",
                profile_image: userImg1,
                reputation: 1347160,
                user_id: 1,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 1,
                badge_counts: {
                    bronze: 9072,
                    silver: 8954,
                    gold: 828
                },
                creation_date: '12 Jan, 20',
                display_name: "John",
                location: "New York",
                profile_image: userImg1,
                reputation: 1347160,
                user_id: 1,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 1,
                badge_counts: {
                    bronze: 9072,
                    silver: 8954,
                    gold: 828
                },
                creation_date: '12 Jan, 20',
                display_name: "Tanbir Ahmod",
                location: "New York",
                profile_image: userImg1,
                reputation: 1347160,
                user_id: 1,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 1,
                badge_counts: {
                    bronze: 9072,
                    silver: 8954,
                    gold: 828
                },
                creation_date: '12 Jan, 20',
                display_name: "Jim",
                location: "New York",
                profile_image: userImg1,
                reputation: 1347160,
                user_id: 1,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 1,
                badge_counts: {
                    bronze: 9072,
                    silver: 8954,
                    gold: 828
                },
                creation_date: '12 Jan, 20',
                display_name: "Mr. Potato",
                location: "New York",
                profile_image: userImg1,
                reputation: 1347160,
                user_id: 1,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 1,
                badge_counts: {
                    bronze: 9072,
                    silver: 8954,
                    gold: 828
                },
                creation_date: '12 Jan, 20',
                display_name: "Tanbir",
                location: "United Kingdom",
                profile_image: userImg1,
                reputation: 1347160,
                user_id: 1,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 1,
                badge_counts: {
                    bronze: 9072,
                    silver: 8954,
                    gold: 828
                },
                creation_date: '12 Jan, 20',
                display_name: "Tanbir Ahmod",
                location: "United Kingdom",
                profile_image: userImg1,
                reputation: 1347160,
                user_id: 1,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 1,
                badge_counts: {
                    bronze: 9072,
                    silver: 8954,
                    gold: 828
                },
                creation_date: '12 Jan, 20',
                display_name: "Tanbir Ahmod",
                location: "United Kingdom",
                profile_image: userImg1,
                reputation: 1347160,
                user_id: 1,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 1,
                badge_counts: {
                    bronze: 9072,
                    silver: 8954,
                    gold: 828
                },
                creation_date: '12 Jan, 20',
                display_name: "Tanbir Ahmod",
                location: "United Kingdom",
                profile_image: userImg1,
                reputation: 1347160,
                user_id: 1,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 1,
                badge_counts: {
                    bronze: 9072,
                    silver: 8954,
                    gold: 828
                },
                creation_date: '12 Jan, 20',
                display_name: "Tanbir Ahmod",
                location: "United Kingdom",
                profile_image: userImg1,
                reputation: 1347160,
                user_id: 1,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 1,
                badge_counts: {
                    bronze: 9072,
                    silver: 8954,
                    gold: 828
                },
                creation_date: '12 Jan, 20',
                display_name: "Tanbir Ahmod",
                location: "United Kingdom",
                profile_image: userImg1,
                reputation: 1347160,
                user_id: 1,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 1,
                badge_counts: {
                    bronze: 9072,
                    silver: 8954,
                    gold: 828
                },
                creation_date: '12 Jan, 20',
                display_name: "Tanbir Ahmod",
                location: "United Kingdom",
                profile_image: userImg3,
                reputation: 1347160,
                user_id: 1,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 1,
                badge_counts: {
                    bronze: 9072,
                    silver: 8954,
                    gold: 828
                },
                creation_date: '12 Jan, 20',
                display_name: "Tanbir Ahmod",
                location: "United Kingdom",
                profile_image: userImg3,
                reputation: 1347160,
                user_id: 1,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 1,
                badge_counts: {
                    bronze: 9072,
                    silver: 8954,
                    gold: 828
                },
                creation_date: '12 Jan, 20',
                display_name: "Tanbir Ahmod",
                location: "United Kingdom",
                profile_image: userImg3,
                reputation: 1347160,
                user_id: 1,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 1,
                badge_counts: {
                    bronze: 9072,
                    silver: 8954,
                    gold: 828
                },
                creation_date: '12 Jan, 20',
                display_name: "Tanbir Ahmod",
                location: "United Kingdom",
                profile_image: userImg3,
                reputation: 1347160,
                user_id: 1,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 1,
                badge_counts: {
                    bronze: 9072,
                    silver: 8954,
                    gold: 828
                },
                creation_date: '12 Jan, 20',
                display_name: "Tanbir Ahmod",
                location: "United Kingdom",
                profile_image: userImg3,
                reputation: 1347160,
                user_id: 1,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 1,
                badge_counts: {
                    bronze: 9072,
                    silver: 8954,
                    gold: 828
                },
                creation_date: '12 Jan, 20',
                display_name: "Tanbir Ahmod",
                location: "United Kingdom",
                profile_image: userImg3,
                reputation: 1347160,
                user_id: 1,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 1,
                badge_counts: {
                    bronze: 9072,
                    silver: 8954,
                    gold: 828
                },
                creation_date: '12 Jan, 20',
                display_name: "Tanbir Ahmod",
                location: "United Kingdom",
                profile_image: userImg1,
                reputation: 1347160,
                user_id: 1,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 1,
                badge_counts: {
                    bronze: 9072,
                    silver: 8954,
                    gold: 828
                },
                creation_date: '12 Jan, 20',
                display_name: "Tanbir Ahmod",
                location: "United Kingdom",
                profile_image: userImg1,
                reputation: 1347160,
                user_id: 1,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 1,
                badge_counts: {
                    bronze: 9072,
                    silver: 8954,
                    gold: 828
                },
                creation_date: '12 Jan, 20',
                display_name: "Tanbir Ahmod",
                location: "United Kingdom",
                profile_image: userImg1,
                reputation: 1347160,
                user_id: 1,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            },
            {
                account_id: 1,
                badge_counts: {
                    bronze: 9072,
                    silver: 8954,
                    gold: 828
                },
                creation_date: '12 Jan, 20',
                display_name: "Tanbir Ahmod",
                location: "United Kingdom",
                profile_image: userImg1,
                reputation: 1347160,
                user_id: 1,
                user_type: "registered",
                website_url: "http://csharpindepth.com",
                tags: [
                    {
                        title: 'css',
                        url: 'css'
                    },
                    {
                        title: 'php',
                        url: 'php'
                    },
                    {
                        title: 'java',
                        url: 'java'
                    }
                ]
            }
        ]
    },
    tagsTab: {
        title: 'Tags',
        description: 'A tag is a keyword or label that categorizes your question with other, similar questions. Using the right tags makes it easier for others to find and answer your question.',
        tags: [
            {
                title: 'javascript',
                description: 'For questions regarding programming in ECMAScript (JavaScript/JS) and its various dialects/implementations (excluding ActionScript). Note...',
                count: '2406395',
                todayAsk: '750',
                thisWeek: '4348'
            },
            {
                title: 'python',
                description: 'Python is a multi-paradigm, dynamically typed, multi-purpose programming language. It is designed to be quick to learn, understand, and...',
                count: '1406324',
                todayAsk: '453',
                thisWeek: '4348'
            },
            {
                title: 'java',
                description: "Java is a high-level object oriented programming language. Use this tag when you're having problems using or understanding the language itself. This...",
                count: '1858407',
                todayAsk: '349',
                thisWeek: '2348'
            },
            {
                title: 'c#',
                description: "C# (pronounced 'see sharp') is a high level, statically typed, multi-paradigm programming language developed by Microsoft. C# code usually targets...",
                count: '1550958',
                todayAsk: '331',
                thisWeek: '1718'
            },
            {
                title: 'php',
                description: "PHP is a widely used, open source, general-purpose, multi-paradigm, dynamically typed and interpreted scripting language originally designed...",
                count: '1441892',
                todayAsk: '218',
                thisWeek: '1258'
            },
            {
                title: 'android',
                description: "Android is Google's mobile operating system, used for programming or developing digital devices (Smartphones, Tablets, Automobiles...",
                count: '1381436',
                todayAsk: '214',
                thisWeek: '1280'
            },
            {
                title: 'html',
                description: "HTML (HyperText Markup Language) is the markup language for creating web pages and other information to be displayed in a web browser. Questio...",
                count: '1139291',
                todayAsk: '253',
                thisWeek: '1517'
            },
            {
                title: 'jquery',
                description: "jQuery is a JavaScript library, consider also adding the JavaScript tag. jQuery is a popular cross-browser JavaScript library that facilitates Document Obje...",
                count: '1028496',
                todayAsk: '79',
                thisWeek: '435'
            },
            {
                title: 'css',
                description: "CSS (Cascading Style Sheets) is a representation style sheet language used for describing the look and formatting of HTML (HyperText Mark...",
                count: '766638',
                todayAsk: '197',
                thisWeek: '1012'
            },
            {
                title: 'node.js',
                description: "Node.js is an event-based, non-blocking, asynchronous I/O runtime that uses Google's V8 JavaScript engine and libuv library. It is used for...",
                count: '437640',
                todayAsk: '204',
                thisWeek: '1224'
            }
        ]
    },
    aboutus: {
        teamData: {
            title: 'Meet dLab Core Team',
            members: [
                {
                    name: 'Developer Tanbir',
                    designation: 'Software Engineer',
                    image: team5
                },
                {
                    name: 'Developer Tanbir',
                    designation: 'Software Engineer',
                    image: team6
                },
                {
                    name: 'Developer Tanbir',
                    designation: 'Software Engineer',
                    image: team7
                },
                {
                    name: 'Developer Tanbir',
                    designation: 'Software Engineer',
                    image: team8
                }
            ]
        }
    },
    badgeTab: {
        title: 'Badges',
        description: 'Besides gaining reputation with your questions and answers, you receive badges for being especially helpful. Badges appear on your profile page, flair, and your posts.',
        badges: {
            question_badge: {
                title: 'Question Badges',
                items: [
                    {
                        name: 'Altruist',
                        award_count: '10.8k',
                        rank: "bronze",
                        badge_id: 1,
                        link: "/altruist",
                        content: "First bounty you manually award on another person's question"
                    },
                    {
                        name: 'Benefactor',
                        award_count: '52.5k',
                        rank: "bronze",
                        badge_id: 2,
                        link: "/benefactor",
                        content: "First bounty you manually award on your own question"
                    },
                    {
                        name: 'Curious',
                        award_count: '393.4k',
                        rank: "bronze",
                        badge_id: 3,
                        link: "/curious",
                        content: "Ask a well-received question on 5 separate days, and maintain a positive question record"
                    },
                    {
                        name: 'Inquisitive',
                        award_count: '39.4k',
                        rank: "silver",
                        badge_id: 4,
                        link: "/inquisitive",
                        content: "Ask a well-received question on 30 separate days, and maintain a positive question record"
                    },
                    {
                        name: 'Socratic',
                        award_count: '5.2k',
                        rank: "gold",
                        badge_id: 5,
                        link: "/socratic",
                        content: "Ask a well-received question on 100 separate days, and maintain a positive question record"
                    },
                    {
                        name: 'Favorite Question',
                        award_count: '66k',
                        rank: "silver",
                        badge_id: 6,
                        link: "/favorite-question",
                        content: "Question bookmarked by 25 users"
                    },
                    {
                        name: 'Stellar Question',
                        award_count: '9.9k',
                        rank: "gold",
                        badge_id: 7,
                        link: "/stellar-question",
                        content: "Question bookmarked by 100 users"
                    },
                    {
                        name: 'Investor',
                        award_count: '52k',
                        rank: "bronze",
                        badge_id: 8,
                        link: "/investor",
                        content: "First bounty you offer on another person's question"
                    },
                    {
                        name: 'Nice Question',
                        award_count: '562.3k',
                        rank: "bronze",
                        badge_id: 9,
                        link: "/nice-question",
                        content: "Question score of 10 or more"
                    },
                    {
                        name: 'Good Question',
                        award_count: '342.3k',
                        rank: "silver",
                        badge_id: 10,
                        link: "/good-question",
                        content: "Question score of 25 or more"
                    },
                    {
                        name: 'Great Question',
                        award_count: '51.7k',
                        rank: "gold",
                        badge_id: 11,
                        link: "/great-question",
                        content: "Question score of 100 or more"
                    },
                    {
                        name: 'Popular Question',
                        award_count: '6.6m',
                        rank: "bronze",
                        badge_id: 12,
                        link: "/popular-question",
                        content: "Question with 1,000 views"
                    },
                    {
                        name: 'Notable Question',
                        award_count: '3.3m',
                        rank: "silver",
                        badge_id: 13,
                        link: "/notable-question",
                        content: "Question with 2,500 views"
                    },
                    {
                        name: 'Famous Question',
                        award_count: '979k',
                        rank: "gold",
                        badge_id: 14,
                        link: "/famous-question",
                        content: "Question with 10,000 views"
                    }
                ]
            },
            answer_badge: {
                title: 'Answer Badges',
                items: [
                    {
                        name: 'Enlightened',
                        award_count: '432.8k',
                        rank: "silver",
                        badge_id: 1,
                        link: "/enlightened",
                        content: "First to answer and accepted with score of 10 or more"
                    },
                    {
                        name: 'Explainer',
                        award_count: '75.5k',
                        rank: "bronze",
                        badge_id: 2,
                        link: "/explainer",
                        content: "Edit and answer 1 question (both actions within 12 hours, answer score > 0)"
                    },
                    {
                        name: 'Refiner',
                        award_count: '23.4k',
                        rank: "bronze",
                        badge_id: 3,
                        link: "/refiner",
                        content: "Edit and answer 50 questions (both actions within 12 hours, answer score > 0)"
                    },
                    {
                        name: 'Illuminator',
                        award_count: '244',
                        rank: "gold",
                        badge_id: 4,
                        link: "/illuminator",
                        content: "Edit and answer 500 questions (both actions within 12 hours, answer score > 0)"
                    },
                    {
                        name: 'Generalist',
                        award_count: '1.2k',
                        rank: "silver",
                        badge_id: 5,
                        link: "/generalist",
                        content: "Provide non-wiki answers of 15 total score in 20 of top 40 tags"
                    },
                    {
                        name: 'Guru',
                        award_count: '166.1k',
                        rank: "silver",
                        badge_id: 6,
                        link: "/guru",
                        content: "Accepted answer and score of 40 or more"
                    },
                    {
                        name: 'Stellar Question',
                        award_count: '9.9k',
                        rank: "gold",
                        badge_id: 7,
                        link: "/stellar-question",
                        content: "Question bookmarked by 100 users"
                    },
                    {
                        name: 'Investor',
                        award_count: '52k',
                        rank: "bronze",
                        badge_id: 8,
                        link: "/investor",
                        content: "First bounty you offer on another person's question"
                    },
                    {
                        name: 'Nice Question',
                        award_count: '562.3k',
                        rank: "bronze",
                        badge_id: 9,
                        link: "/nice-question",
                        content: "Question score of 10 or more"
                    },
                    {
                        name: 'Good Question',
                        award_count: '342.3k',
                        rank: "silver",
                        badge_id: 10,
                        link: "/good-question",
                        content: "Question score of 25 or more"
                    },
                    {
                        name: 'Great Question',
                        award_count: '51.7k',
                        rank: "gold",
                        badge_id: 11,
                        link: "/great-question",
                        content: "Question score of 100 or more"
                    },
                    {
                        name: 'Popular Question',
                        award_count: '6.6m',
                        rank: "bronze",
                        badge_id: 12,
                        link: "/popular-question",
                        content: "Question with 1,000 views"
                    },
                    {
                        name: 'Notable Question',
                        award_count: '3.3m',
                        rank: "silver",
                        badge_id: 13,
                        link: "/notable-question",
                        content: "Question with 2,500 views"
                    },
                    {
                        name: 'Famous Question',
                        award_count: '979k',
                        rank: "gold",
                        badge_id: 14,
                        link: "/famous-question",
                        content: "Question with 10,000 views"
                    }
                ]
            }
        }
    },
    testimonialData: {
        title: 'Testimonial',
        items: [
            {
                name: 'John Doe',
                designation: 'Software Engineer',
                image: team4,
                content: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Harum dolores nam eveniet tempora dolorum molestias atque rem esse odit eligendi repudiandae necessitatibus voluptas fugiat cupiditate, assumenda illo ea, repellendus molestiae quos architecto!'
            },
            {
                name: 'John Doe',
                designation: 'Software Engineer',
                image: team1,
                content: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Harum dolores nam eveniet tempora dolorum molestias atque rem esse odit eligendi repudiandae necessitatibus voluptas fugiat cupiditate, assumenda illo ea, repellendus molestiae quos architecto molestiae quos architecto!'
            },
            {
                name: 'John Doe',
                designation: 'Software Engineer',
                image: team2,
                content: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Harum dolores nam eveniet tempora dolorum molestias atque rem esse odit eligendi repudiandae necessitatibus voluptas fugiat cupiditate, assumenda illo ea, repellendus molestiae quos architecto!'
            }
        ]
    },
    faqSectionData: {
        faqLists: [
            {
                title: 'Why do I see a message that my question does not meet standards?',
                content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam consectetur sit amet ante nec vulputate. Nulla aliquam, justo auctor consequat tincidunt, arcu erat mattis lorem consectetur adipiscing elit. justo auctor consequat tincidunt, arcu erat mattis lorem consectetur adipiscing elit.'
            },
            {
                title: 'What topics can I ask about here?',
                content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam consectetur sit amet ante nec vulputate. Nulla aliquam, justo auctor consequat tincidunt, arcu erat mattis lorem consectetur adipiscing elit.'
            },
            {
                title: 'What types of questions should I avoid asking?',
                content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam consectetur sit amet ante nec vulputate. Nulla aliquam, justo auctor consequat tincidunt, arcu erat mattis lorem consectetur adipiscing elit.'
            },
            {
                title: 'What does it mean if a question is',
                content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam consectetur sit amet ante nec vulputate. Nulla aliquam, justo auctor consequat tincidunt, arcu erat mattis lorem consectetur adipiscing elit.'
            },
            {
                title: 'How to create a Minimal, Complete, and Verifiable example',
                content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam consectetur sit amet ante nec vulputate. Nulla aliquam, justo auctor consequat tincidunt, arcu erat mattis lorem consectetur adipiscing elit.'
            },
            {
                title: 'What if I disagree with the closure of a question? How to reopen it?',
                content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam consectetur sit amet ante nec vulputate. Nulla aliquam, justo auctor consequat tincidunt, arcu erat mattis lorem consectetur adipiscing elit.'
            },
            {
                title: 'Why do I see a message that my question does not meet standards?',
                content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam consectetur sit amet ante nec vulputate. Nulla aliquam, justo auctor consequat tincidunt, arcu erat mattis lorem consectetur adipiscing elit.'
            },
            {
                title: 'Why are some questions marked as duplicate?',
                content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam consectetur sit amet ante nec vulputate. Nulla aliquam, justo auctor consequat tincidunt, arcu erat mattis lorem consectetur adipiscing elit.'
            },
            {
                title: 'What should I do when someone answers my question?',
                content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam consectetur sit amet ante nec vulputate. Nulla aliquam, justo auctor consequat tincidunt, arcu erat mattis lorem consectetur adipiscing elit.'
            }
        ]
    },
    blogData: {
        blogItems: [
            {
                id: 1,
                title: 'Open space - new trend in office design',
                url: '/blog-details',
                author: 'Developer Tanbir',
                authorUrl: '',
                authorImage: team1,
                img: blogImg1,
                date: 'Feb 25, 2021',
                tags: [
                    {
                        title: 'Business',
                        url: '#'
                    },
                    {
                        title: 'Finance',
                        url: '#'
                    }
                ]
            },
            {
                id: 2,
                title: 'What You Can Learn About Managing Projects',
                url: '/blog-details',
                author: 'Tanbir',
                authorUrl: '',
                authorImage: team2,
                img: blogImg2,
                date: 'Feb 28, 2021',
                tags: [
                    {
                        title: 'Project Management',
                        url: '#'
                    }
                ]
            },
            {
                id: 3,
                title: 'Designers should always keep their users in mind',
                url: '/blog-details',
                author: 'Developer Tanbir',
                authorUrl: '',
                authorImage: team3,
                img: blogImg3,
                date: 'Feb 28, 2021',
                tags: [
                    {
                        title: 'Digital design',
                        url: '#'
                    }
                ]
            },
            {
                id: 4,
                title: 'Open space - new trend in office design',
                url: '/blog-details',
                author: 'Developer Tanbir',
                authorUrl: '',
                authorImage: team4,
                img: blogImg1,
                date: 'Feb 25, 2021',
                tags: [
                    {
                        title: 'Business',
                        url: '#'
                    },
                    {
                        title: 'Finance',
                        url: '#'
                    }
                ]
            },
            {
                id: 5,
                title: 'What You Can Learn About Managing Projects',
                url: '/blog-details',
                author: 'Tanbir',
                authorUrl: '',
                authorImage: team1,
                img: blogImg2,
                date: 'Feb 28, 2021',
                tags: [
                    {
                        title: 'Project Management',
                        url: '#'
                    }
                ]
            },
            {
                id: 6,
                title: 'Designers should always keep their users in mind',
                url: '/blog-details',
                author: 'Developer Tanbir',
                authorUrl: '',
                authorImage: team2,
                img: blogImg3,
                date: 'Feb 28, 2021',
                tags: [
                    {
                        title: 'Digital design',
                        url: '#'
                    }
                ]
            }
        ],
        sidebar: {
            categories: {
                title: 'Categories',
                lists: [
                    {
                        id: 0,
                        title: 'Business',
                        count: 429,
                        path: '/'
                    },
                    {
                        id: 1,
                        title: 'Finance',
                        count: 234,
                        path: '/'
                    },
                    {
                        id: 2,
                        title: 'Digital Design',
                        count: 438,
                        path: '/'
                    },
                    {
                        id: 3,
                        title: 'Project Management',
                        count: 122,
                        path: '/'
                    },
                    {
                        id: 4,
                        title: 'Technology',
                        count: 322,
                        path: '/'
                    },
                    {
                        id: 5,
                        title: 'Marketing',
                        count: 223,
                        path: '/'
                    }
                ]
            },
            tags: {
                title: 'Tags',
                items: [
                    {
                        title: 'php',
                        url: '/'
                    },
                    {
                        title: 'html',
                        url: '/'
                    },
                    {
                        title: 'css',
                        url: '/'
                    },
                    {
                        title: 'analytics',
                        url: '/'
                    },
                    {
                        title: 'computer',
                        url: '/'
                    },
                    {
                        title: 'wp',
                        url: '/'
                    },
                    {
                        title: 'python',
                        url: '/'
                    },
                    {
                        title: 'java',
                        url: '/'
                    },
                    {
                        title: 'swift',
                        url: '/'
                    },
                    {
                        title: 'javascript',
                        url: '/'
                    },
                    {
                        title: 'c#',
                        url: '/'
                    },
                    {
                        title: 'machine-language',
                        url: '/'
                    }
                ]
            },
            trendingPosts: {
                title: 'Trending Posts',
                posts: [
                    {
                        title: 'image picker and store them into firebase with flutter',
                        path: '/blog-details',
                        user: 'Antonin gavrel',
                        date: '11 Jul, 22'
                    },
                    {
                        title: 'Using web3 to call precompile contract',
                        path: '/blog-details',
                        user: 'wimax',
                        date: '23 Jul, 22'
                    },
                    {
                        title: 'Is it true while finding Time Complexity of the algorithm [closed]',
                        path: '/blog-details',
                        user: 'Antonin gavrel',
                        date: '23 Jul, 22'
                    }
                ]
            }
        },
        relatedPost: {
            title: 'Related Posts',
            items: [
                {
                    id: 1,
                    title: 'Open space - new trend in office design',
                    url: '/blog-details',
                    author: 'Developer Tanbir',
                    authorUrl: '',
                    authorImage: team1,
                    img: blogImg1,
                    date: 'Feb 25, 2021',
                    tags: [
                        {
                            title: 'Business',
                            url: '#'
                        },
                        {
                            title: 'Finance',
                            url: '#'
                        }
                    ]
                },
                {
                    id: 2,
                    title: 'What You Can Learn About Managing Projects',
                    url: '/blog-details',
                    author: 'Tanbir',
                    authorUrl: '',
                    authorImage: team2,
                    img: blogImg2,
                    date: 'Feb 28, 2021',
                    tags: [
                        {
                            title: 'Project Management',
                            url: '#'
                        }
                    ]
                },
                {
                    id: 3,
                    title: 'Designers should always keep their users in mind',
                    url: '/blog-details',
                    author: 'John Doe',
                    authorUrl: '',
                    authorImage: team3,
                    img: blogImg3,
                    date: 'Feb 28, 2021',
                    tags: [
                        {
                            title: 'Digital design',
                            url: '#'
                        }
                    ]
                }

            ]
        }
    },
    getStarted: {
        title: "dLab Q &amp; A communities are different. Here's how",
        description: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        bgImage: getStartedBgShape,
        items: [
            {
                title: 'Share knowledge earn trust.',
                content: 'There are many variations of passages of Lorem Ipsum available, but the majority have suffered.',
                img: vote
            },
            {
                title: 'Expert communities.',
                content: 'There are many variations of passages of Lorem Ipsum available, but the majority have suffered.',
                img: communities
            },
            {
                title: 'The right answer on top.',
                content: 'There are many variations of passages of Lorem Ipsum available, but the majority have suffered.',
                img: checked
            }
        ]
    },
    footer: {
        logo: logo,
        description: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Placeat porro inventore voluptatum fuga sint ex.',
        footerCompany: {
            title: 'Company',
            links: [
                {
                    title: 'About',
                    url: '/about-us'
                },
                {
                    title: 'Privacy Policy',
                    url: '/privacy-policy'
                },
                {
                    title: 'Terms of Services',
                    url: '/'
                },
                {
                    title: 'Cookie Policy',
                    url: '/'
                },
                {
                    title: 'Cookie Settings',
                    url: '/'
                },
                {
                    title: 'Contact Us',
                    url: '/contact'
                },
                {
                    title: 'Careers',
                    url: '/'
                }
            ]
        },
        footerHelp: {
            title: 'Help',
            links: [
                {
                    title: 'Questions',
                    url: '/'
                },
                {
                    title: 'Help',
                    url: '/'
                }
            ]
        }
    }

}
export default dlabData